var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-head'),_c('main',{staticClass:"content",attrs:{"id":"contentPDF"}},[_c('v-base-info'),_c('v-content')],1),_c('v-foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }